
import Header from "../components/header";
import Sidebar from "../components/sidebar";
import NewCustomer from "../components/newCustomer";
import Footer from "../components/footer";

function NewCustomerPage() {
  return (
    <div>
    <div className='wrapper'>
      <Header />
      <Sidebar /> 
      <NewCustomer /> 
    </div>
    <Footer /> 
  </div>
  // <Login/>
  );
}
export default NewCustomerPage;
